import type { Locale } from 'date-fns';
import enUsLocale from 'date-fns/locale/en-US';

import { formatLong } from './formatLong';
import { localize } from './localize';

/**
 * @type {Locale}
 * @category Locales
 * @summary Amharic locale.
 * @language Amharic
 */
export const amLocale: Locale = {
  code: 'am',
  formatDistance: enUsLocale.formatDistance,
  formatLong,
  formatRelative: enUsLocale.formatRelative,
  localize,
  match: enUsLocale.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
};
